export default __webpack_public_path__ + "static/m-sizzling5-6e95430b3b8a8536380cbee65097928e.jpg";